module.exports = __webpack_public_path__ + "img/accounting-invoice.d7b80a44.svg";